
class SleepUtils {

    public static async sleep(ms: number): Promise<void> {
        return new Promise(resolve => setTimeout(()=> resolve(), ms));
    }
}

export default SleepUtils;
